<template>
  <AuthCard
      class="success-card"
      :title="t('page.signup-success-title')"
      :subtitle="t('page.signup-success-subtitle')"
  >
    <img :src="sentImg" alt="icon_plane" />

    <a-button
        class="success-card__button full-width"
        type="primary"
        @click="emit('back')"
    >
      {{ t('ui.back-to-login-button') }}
    </a-button>
  </AuthCard>
</template>

<script setup lang="ts">
import { AuthCard } from '@/ui/common/auth'
import sentImg from '@/assets/images/sent.svg'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const emit = defineEmits<{
  (e: 'back'): void
}>()
</script>

<style lang="scss" scoped>
.success-card {
  &__image {
    width: 320px;
    height: 300px;
    margin: 32px auto;
    display: block;
  }

  &__button {
    margin-top: 24px;
  }
}
</style>